import { TiposDeBusca } from '../protocols';

export const tiposDeBuscaDefault: TiposDeBusca = {
  cliente: true,
  fornecedor: true,
  loja: true,
};
